import { useState } from 'react'

import { Box, Button, SearchField, Text } from '@factorialco/deprecated-design-system'
import {
  type SoftwareManagementSoftwareInfoSoftwareSetupFragment,
  SoftwareWizardEmployeeFragment,
} from 'generated/resources/graphql'

import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import SoftwareListFilters from 'modules/software_management/components/SoftwareListFilters'
import SoftwareInfo from 'modules/software_management/components/SoftwareSetupsList/_SoftwareInfo'
import SoftwareWizard from 'modules/software_management/components/SoftwareWizard'

type directionType = 'asc' | 'desc'

interface Props {
  softwareSetups: SoftwareManagementSoftwareInfoSoftwareSetupFragment[]
  currency: string
  attribute: string
  setAttribute: (attribute: string) => void
  direction: directionType | undefined
  setDirection: (direction: directionType | undefined) => void
  search: string
  onSearch: (event: React.ChangeEvent<HTMLInputElement>) => void
  employee: SoftwareWizardEmployeeFragment
  onSoftwareCreated: (setupId: string) => void
}

const SoftwareSetupsList = ({
  softwareSetups,
  currency,
  attribute,
  setAttribute,
  direction,
  setDirection,
  search,
  onSearch,
  employee,
  onSoftwareCreated,
}: Props) => {
  const [showNewModal, setShowNewModal] = useState<boolean>(false)

  const showNewModalHandler = () => {
    track(trackingEvents.softwareManagement.openSoftwareSetupWizard)
    setShowNewModal(true)
  }

  return (
    <Box gap="s12" flexDirection="row" flexWrap="wrap" alignItems="center" justifyContent="center">
      <Box width="full" flexDirection="row" justifyContent="spaceBetween" alignItems="center">
        <Text.Header2 weight="semibold">
          {i18n.t('software_management.software_setups.list.app_count', {
            count: softwareSetups.length,
          })}
        </Text.Header2>
        <Button type="primary" iconName="add" onClick={showNewModalHandler}>
          {i18n.t('software_management.software_setups.list.cta')}
        </Button>
      </Box>
      <Box width="full" flexDirection="row">
        <Box gap="s12" flexDirection="row">
          <SearchField
            variant="regular"
            onSearch={onSearch}
            search={search}
            placeholder={i18n.t('common.search')}
          />
          <SoftwareListFilters
            attribute={attribute}
            setAttribute={setAttribute}
            direction={direction}
            setDirection={setDirection}
          />
        </Box>
      </Box>

      <Box
        width="full"
        minHeight="s200"
        flexDirection="row"
        flexWrap="wrap"
        justifyContent="flexStart"
        gap="s12"
      >
        {softwareSetups.map((softwareSetup) => (
          <SoftwareInfo key={softwareSetup.id} softwareSetup={softwareSetup} currency={currency} />
        ))}
      </Box>
      {showNewModal && (
        <SoftwareWizard
          onSuccess={onSoftwareCreated}
          employee={employee}
          onClose={() => setShowNewModal(false)}
        />
      )}
    </Box>
  )
}

export default SoftwareSetupsList
